<i18n>
{
	"en": {
		"status": "Operational status",
		"cancelled": "Cancelled",
		"draft": "Draft",
		"received": "Received",
		"rejected": "Rejected",
		"ready": "Ready",
		"planned": "Planned",
		"unsuccessful": "Unsuccessful",
		"requested": "Requested",
		"accepted": "Accepted",
		"selectStatus": "Select status",
		"readyForPickup": "Ready for pickup",
		"loaded": "Loaded",
		"unloaded": "Unloaded"
	},
	"no": {
		"status": "Operativ status",
		"cancelled": "Annullert",
		"draft": "Kladd",
		"received": "Mottatt",
		"rejected": "Avslått",
		"ready": "Klar",
		"planned": "Planlagt",
		"unsuccessful": "Bomtur",
		"requested": "Forespurt",
		"accepted": "Akseptert",
		"selectStatus": "Velg status",
		"readyForPickup": "Klar for henting",
		"loaded": "Lastet",
		"unloaded": "Losset"
	}
}
</i18n>
<template>
	<t-form-group :title="$t('status')">
		<slot name="before" />
		<t-select
			:items="availableStatuses"
			:selectedItem="selectedItem"
			:selectedItems="selectedItems"
			:relative="relative"
			:showPopoverOnFocus="showPopoverOnFocus"
			@change="$emit('change', $event)"
		>
			<template #displayedValue>
				<div v-if="selectedItem !== undefined" class="list-item">
					<t-status-color-dot :color="getStatusColor(selectedItem)" />
					<div>
						{{$t(getStatusLabel(selectedItem))}}
					</div>
				</div>
				<div v-else>{{ $t('selectStatus') }}</div>
			</template>

			<template #optionItemValue="{ item }">
				<div class="list-item">
					<t-status-color-dot :color="getStatusColor(item)" />
					<div>
						{{ $t(getStatusLabel(item)) }}
					</div>
				</div>
			</template>
			<!-- This enables slots to be overwritten if the slot is defined further out -->
			<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
				<slot :name="slot" v-bind="scope"/>
			</template>
		</t-select>
		<slot name="after" />
	</t-form-group>
</template>

<script>
import { statuses } from '@/core';

export default {
	name: 'OperationalStatusFormInput',
	props: {
		relative: Boolean,
		selectedItem: Number,
		selectedItems: {
			type: Array,
			default: () => []
		},
		availableStatuses: {
			type: Array,
			default: () => Object.values(statuses.operational)
		},
		showPopoverOnFocus: Boolean,
	},
	methods: {
		getStatusLabel(status) {
			return statuses.operational(status);
		},
		getStatusColor(status) {
			return statuses.color(status);
		}
	}
};
</script>

<style lang="scss" scoped>
.list-item {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	> * {
		margin-right: 5px;
	}
}
</style>